<template>
<div>
	<edit-container 
		ref="editContainer"
		type="person" 
		:handle="['edit','add','replace','refund']"
		:file-url="fileUrl"
		@add="add"
		@batch-add="batchAdd"
		@edit="edit"
		@replace="replace"
		@refund="refund"
		@set-data="setData"
		@set-info="setInfo">
		<SchemeTable class="mt10" slot="thead" :type="isOld?'oldPerson':'person'" :quoteVersion="quoteVersion" />
		<div slot="file" class="mt20">
			<div v-if="type=='PERSON'">
				<Alert type="warning">
					请将新增和新替换的参加人员上传雇佣合同，无相关材料人员出险后保险公司有权拒赔。
				</Alert>
				<UploadFileImg @on-success="uploadSuccess" style="width:200px">
					<div class="mt10">
						<Icon type="ios-cloud-upload-outline" size="20" />
						<p>{{fileUrl?'重新':''}}上传雇佣合同</p>
					</div>
					<a :href="fileUrl" target="_blank" v-if="fileUrl" @click.stop>查看</a>
				</UploadFileImg>
			</div>
		</div>
	</edit-container>
	
	<Modal
		v-model="addShow"
		title="添加人员信息"
        width="400px"
        :mask-closable="false">
		<Form :model="addForm" ref="addForm" :label-width="100" :rules="addFormRules">
			<FormItem label="姓名" prop="insuredPersonName">
		        <Input type="text" v-model="addForm.insuredPersonName" ></Input>
		    </FormItem>
		    <FormItem label="证件号" prop="idCard">
		        <Input type="text" v-model="addForm.idCard" ></Input>
		    </FormItem>
			<FormItem label="保障起期" prop="effectiveDateStart">
				<DatePicker 
					v-model="addForm.effectiveDateStart" 
					type="date" 
					placeholder="请选择保障起期" 
					style="width: 100%"
					:options="dateOptions">
				</DatePicker>
			</FormItem>
			<FormItem label="保障止期">
				{{ info.effectiveDateEnd }}
			</FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="addShow=false">取消</Button>
			<Button type="primary" @click="confirmAdd" >确定</Button>
		</template>
	</Modal>
	<Modal
		v-model="editShow"
		title="编辑人员信息"
        width="400px"
        :mask-closable="false">
		<Form :model="editForm" ref="editForm" :label-width="100" :rules="editFormRules" @submit.native.prevent>
			<FormItem label="姓名" prop="insuredPersonName">
		        <Input type="text" v-model="editForm.insuredPersonName" ></Input>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="editShow=false">取消</Button>
			<Button type="primary" @click="confirmEdit">确定</Button>
		</template>
	</Modal>
	
	<Modal
		v-model="replaceShow"
		title="人员替换"
        :mask-closable="false">
		<Card title="原员工">
			<Form :label-width="90">
				<FormItem label="姓名：" class="mb0">
					{{replaceData.insuredPersonName}}
				</FormItem>
				<FormItem label="证件号：" class="mb0">
					{{replaceData.idCard}}
				</FormItem>
			
				<FormItem label="保障方案：" class="mb0">
					{{replaceData.scheme}}
				</FormItem>
			</Form>
		</Card>
		<Card title="替换后员工">
			<Alert type="warning">保障方案同被替换员工一致</Alert>
			<Form :model="replaceForm" ref="replaceForm" :label-width="100" :rules="replaceFormRules">
				<FormItem label="姓名" prop="insuredPersonName">
					<Input type="text" v-model="replaceForm.insuredPersonName" ></Input>
				</FormItem>
				<FormItem label="证件号" prop="idCard">
					<Input type="text" v-model="replaceForm.idCard" ></Input>
				</FormItem>
			</Form>
		</Card>
		
		<template slot="footer">
			<Button type="text" @click="replaceShow=false">取消</Button>
			<Button type="primary" @click="confirmReplace" >确定</Button>
		</template>
	</Modal>

	<!-- 批量添加弹窗 -->
	<Modal v-model="batchAddShow"  title="批量添加" width="80%" :mask-closable="false" @on-cancel="batchAddCancel">
		<div class="batch-add-container">
			<div class="upload-section">
				<div class="upload-header">
					<span class="upload-label">上传数据:</span>
					<Upload :max-size="20480" :headers="{'is-desensitization':'false'}" action="/pc/broker/import/importEndorseEmployee"  :data="uploadParams" :show-upload-list="false" :on-success="handleBatchSuccess" :on-exceeded-size="handleMaxSize">
						<Button icon="ios-cloud-upload-outline">上传</Button>
					</Upload>
					<a class="ml15" href="/static/excel/货车雇主责任险-按人批改表模板.xlsx" target="_blank">下载模版</a>
				</div>
				<div class="upload-result" v-if="uploadResult&&uploadResult.list.length>0">
					<span class="success-count">正确 {{uploadResult.successCount}}条,</span>
					<span class="error-count">错误{{uploadResult.errorCount}}条</span>
				</div>
			</div>
			<div class="instructions" v-if="!uploadResult||uploadResult.list.length==0">
				<p class="instructions-title">说明:</p>
				<p>1) 请按照模板格式填写，否则无法导入成功</p>
				<p>2) 上传后，请根据提示的正确数据、错误数据数量进行检查</p>
				<p>3) 检查无误后，点击"导入"按钮进行导入，如有误请点击"取消"</p>
				<p>4) 如存在错误数据，无法导入成功</p>
			</div>
			<div class="error-table" v-if="uploadResult && uploadResult.list">
				<el-table ref="selection" :data="uploadResult.list" border>
					<el-table-column type="index" label="序号" width="55" fixed="left"></el-table-column>
					<el-table-column prop="checkMsg" label="校验结果" min-width="200">
						<template slot-scope="{ row }">
							<span class="error" v-if="!row.checkResult.empty">
								{{row.checkResult.result}}
							</span>
							<span class="success" v-else>
								校验通过
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="insuredPersonName" label="姓名" min-width="150"></el-table-column>
					<el-table-column prop="idCard" label="身份证号" min-width="190"></el-table-column>
				</el-table>
			</div>
		</div>
		<div slot="footer" class="footer-btn">
			<Button type="text" @click="batchAddCancel">取消</Button>
			<Button type="primary" @click="confirmBatchAdd" :disabled="!uploadResult||uploadResult.errorCount > 0 || isBatchImporting">导入</Button>
		</div>
	</Modal>
</div>
</template>
<script>
import SchemeTable from '../common/SchemeTable'
import EditContainer from '@/pages/haierProduct/components/common/EditContainer'
import UploadFileImg from '@/components/common/UploadFileImg'
export default {
	components:{ SchemeTable,EditContainer,UploadFileImg },
	data () {
		return {
			list:[],
			info:{},
			addShow:false,
			addForm:{},
			addFormRules:{
				insuredPersonName:{required:true,message:'请填写姓名',trigger:'blur'},
				idCard:[{required:true,message:'请填写证件号',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.idcard}],
				effectiveDateStart:{required:true,message:'请选择保障起期',type:'date',trigger:'change'}
			},
			dateOptions:{},
			editShow:false,
			editForm:{},
			editFormRules:{
				insuredPersonName:{required:true,message:'请填写姓名',trigger:'blur'},
			},
			replaceShow:false,
			replaceData:{},
			replaceForm:{},
			replaceFormRules:{
				insuredPersonName:{required:true,message:'请填写姓名',trigger:'blur'},
				idCard:[{required:true,message:'请填写证件号',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.idcard}],
			},
			fileUrl:'',
			type:'',
			isOld:true,
			quoteVersion:1,
			// 批量添加相关
			batchAddShow:false,
			uploadResult:null,
			batchAddList:[],
			isBatchImporting:false
		}
	},
	computed:{
		canBatchImport(){
			return this.batchSuccessList.length>0 && this.batchErrorList.length===0
		},
		uploadParams(){
			return {
				endorse:JSON.stringify({
					productCode:this.info.productCode,
					bizId:this.info.bizId,
					insurancePolicyId: this.info.insurancePolicyId
				})
			}
		},
	},
	created () {
	},
	methods:{
		setInfo(info){
			console.log(info,'info99999999999999')
			this.info = info;
			this.type=info.applicantInfo?info.applicantInfo.identityType:''
			this.fileUrl=this.type=='COMPANY'?'NO':''
			this.isOld=info.createTime&&Date.parse(info.createTime)<Date.parse('2021/08/02 00:00:00')
			this.quoteVersion = info.quoteVersion;
		},
		setData(list) {
			this.list=list;
		},
        uploadSuccess(val){
            this.fileUrl=val.url
        },
		// 添加
		add() {
			this.addShow=true;
			this.$refs.addForm.resetFields();
			this.addForm={
				operation:'ADD'
			};
			const tomorrow = new Date(); tomorrow.setDate(tomorrow.getDate() + 1);
			this.addForm.effectiveDateStart = tomorrow;
			const endDate = new Date(this.info.effectiveDateEnd);
			this.dateOptions = {
				disabledDate: (time) => {
					tomorrow.setHours(0, 0, 0, 0);
					const isBeforeToday = time.getTime() < tomorrow.getTime();
					endDate.setHours(23, 59, 59, 999);
					const isAfterEndDate = time.getTime() > endDate.getTime();
					return isBeforeToday || isAfterEndDate;
				}
			};
		},
		batchAddCancel(){
			this.batchAddShow=false;
			this.uploadResult=null;
		},
		handleMaxSize (file) {
			this.$Notice.warning({
				title: '提示',
				desc: '附件不可超过20MB'
			});
		},
		// 打开批量添加弹窗
		batchAdd(){
			this.batchAddShow=true;
			this.uploadResult=null;
			this.batchAddList=[];
		},
		// 批量上传成功处理
		handleBatchSuccess(res){
			console.log(res,'上传成功')
			if(res.code==10000000){
				let successList=res.data.filter(item=>item.checkResult.empty);
				let errorList=res.data.filter(item=>!item.checkResult.empty);
				this.uploadResult={
					successCount:successList.length,
					errorCount:errorList.length,
					list:res.data
				};
				this.batchAddList=successList;
			}else{
				this.$Notice.error({
					title: '上传失败',
					desc: res.msg || '文件上传失败'
				});
			}
		},
		// 确认批量导入
		async confirmBatchAdd(){
			this.isBatchImporting=true;
			try{
				this.batchAddList.forEach((item,index)=>{
					item.operation='ADD'
					this.list.push(item);
				});
				// this.list.forEach((item,index)=>{
				// 	item.no=index+1;
				// });
				this.batchAddShow=false;
				this.uploadResult=null;
				this.batchAddList=[];
			}finally{
				this.isBatchImporting=false;
			}
		},
		// 确定
		confirmAdd(){
			this.$refs.addForm.validate(async valid=>{
				if(valid){
					let index=this.list.findIndex(item=>{
						return item.idCard==this.addForm.idCard&&item.operation!='REMOVE'
					})
					if(index!=-1){
						this.alert('此身份证号对应人员已承保')
						return
					}
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push({
						idCard:this.addForm.idCard,
						insuredPersonName:this.addForm.insuredPersonName,
						operation:'ADD',
						extraInfo:{
							effectiveDateStart: this.formatDate(this.addForm.effectiveDateStart)
						}
					})
					await this.$refs.editContainer.getHandleList(list)
					this.addShow=false
				}
			})
		},
		// 打开修改名字
		edit(row){
			this.editShow=true;
			this.$refs.editForm.resetFields();
			this.editForm=this.jsonCopy(row);
		},
		// 确定修改
		confirmEdit(){
			this.$refs.editForm.validate(async valid=>{
				if(valid){
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push({
						...this.editForm,
						operation:'EDIT',
						refIdCard: this.editForm.idCard
					})
					await this.$refs.editContainer.getHandleList(list)
					this.editShow=false;
				}
			})
		},
		// 打开替换
		replace(row) {
			this.replaceShow=true;
			this.$refs.replaceForm.resetFields();
			this.replaceData=row;
			this.replaceForm={
				no:row.no
			};
		},
		// 退保
		refund(row) {
			this.confirm('确定该名员工退出保障计划吗？<br />确认后，将把员工状态临时置为已失效，“提交信息”后才最终生效', () => {
				let list = this.list.filter(item => item.operation !== 'INIT');
				list.push({
					...row,
					operation: 'REMOVE',
					refIdCard: row.idCard
				});
				this.$refs.editContainer.getHandleList(list);
			});
		},
		// 确定替换
		confirmReplace() {
			this.$refs.replaceForm.validate(async valid=>{
				if(valid){
					let index=this.list.findIndex(item=>{
						return item.idCard==this.replaceForm.idCard&&item.operation!='REMOVE'
					})
					if(index!=-1){
						this.alert('此身份证号对应人员已承保')
						return
					}
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push({
						...this.replaceForm,
						operation:'REPLACE',
						refIdCard: this.replaceData.idCard
					})
					await this.$refs.editContainer.getHandleList(list)
					this.replaceShow=false;
				}
			})
		},
	}
}
</script>
<style scoped lang="less">
	.success{
		color:green;
	}
	.error{
		color:red;
	}
	.mb0{
		margin-bottom: 0;
	}
	.batch-add-container{
		padding: 20px;
		.upload-section{
			margin-bottom: 20px;
			.upload-header{
				display: flex;
				align-items: center;
				gap: 15px;
				.upload-label{
					font-weight: bold;
				}
				.download-link{
					color: #1890ff;
					text-decoration: none;
					margin-left: 10px;
				}
			}
			.upload-result{
				margin-top: 15px;
				padding: 10px;
				background: #f5f5f5;
				border-radius: 4px;
				.success-count{
					color: green;
					margin-right: 10px;
				}
				.error-count{
					color: red;
				}
			}
		}
		.instructions{
			background: #fff7e6;
			border-left: 4px solid #faad14;
			padding: 15px;
			margin-bottom: 20px;
			.instructions-title{
				font-weight: bold;
				margin-bottom: 10px;
			}
			p{
				margin: 5px 0;
				font-size: 14px;
				color: #666;
			}
		}
		.error-table{
			max-height: 300px;
			overflow-y: auto;
			margin-bottom: 20px;
		}
		.footer-btn{
			text-align: right;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/person/Edit.vue